import { css } from "styled-components"

export const globals = {
  blueberry: "#3a4665",
  blueberryRGB: "58, 70, 101",
  ebony: "#70464f",
  error: "#c90a0a",
  greyLight: "#f2f2f2",
  greyLightRGB: "242, 242, 242",
  greyLightAlt: "#e7e7e7",
  greyWarm: "#e8e2e1",
  greyWarmRGB: "232, 226, 225",
  greyWarmAlt: "#d9d1d0",
  rose: "#e2a7ae",
  sage: "#a3aba9",
  sageRGB: "163, 171, 169",
  sky: "#b5d1f0",
  spaceblue: "#1b2230",
  spaceblueRGB: "27, 34, 48",
  success: "#2ca58d",
  sun: "#ff6432",
  transitionTime: "250ms",
  white: "#fff",
  whiteRGB: "255, 255, 255",
}

export const lightTheme = {
  ...globals,
}

export const darkTheme = {
  ...globals,
}

export const headerSpacing = {
  gap: "20px",
  gapMd: "30px",
}

export const breakpoint = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  tablet: 768,
  desktop: 992,
}

export const media = {
  xs: `(min-width: ${breakpoint.xs}px)`,
  sm: `(min-width: ${breakpoint.sm}px)`,
  md: `(min-width: ${breakpoint.md}px)`,
  lg: `(min-width: ${breakpoint.lg}px)`,
  xl: `(min-width: ${breakpoint.xl}px)`,
  xxl: `(min-width: ${breakpoint.xxl}px)`,
  tablet: `(min-width: ${breakpoint.tablet}px)`,
  desktop: `(min-width: ${breakpoint.desktop}px)`,
  smDown: `(max-width: ${breakpoint.sm - 1}px)`,
  mdDown: `(max-width: ${breakpoint.md - 1}px)`,
  lgDown: `(max-width: ${breakpoint.lg - 1}px)`,
  xlDown: `(max-width: ${breakpoint.xl - 1}px)`,
  xxlDown: `(max-width: ${breakpoint.xxl - 1}px)`,
}

export const mixins = {
  title1: css`
    font-size: 38px;
    font-weight: 300;
    letter-spacing: -0.6px;
    line-height: 42px;

    @media ${media.xl} {
      font-size: 72px;
      font-weight: 300;
      letter-spacing: -1.2px;
      line-height: 80px;
    }
  `,

  title2: css`
    font-size: 30px;
    font-weight: 300;
    letter-spacing: -0.4px;
    line-height: 37px;

    @media ${media.xl} {
      font-size: 64px;
      font-weight: 300;
      letter-spacing: -1px;
      line-height: 70px;
    }
  `,

  title3: css`
    font-size: 30px;
    font-weight: 300;
    letter-spacing: -0.4px;
    line-height: 35px;

    @media ${media.xl} {
      font-size: 48px;
      font-weight: 300;
      letter-spacing: -0.1px;
      line-height: 54px;
    }
  `,

  title4: css`
    font-size: 24px;
    font-weight: 300;
    letter-spacing: -0.4px;
    line-height: 29px;

    @media ${media.xl} {
      font-size: 33px;
      font-weight: 300;
      letter-spacing: -0.5px;
      line-height: 42px;
    }
  `,

  title5: css`
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-transform: uppercase;

    @media ${media.xl} {
      font-size: 21px;
      font-weight: 700;
      letter-spacing: 0.6px;
      line-height: 30px;
    }
  `,

  title6: css`
    font-size: 19px;
    font-weight: 700;
    line-height: 30px;

    @media ${media.xl} {
      font-size: 24px;
      font-weight: 700;
      line-height: 30px;
    }
  `,

  copy1: css`
    font-size: 20px;
    font-weight: 300;
    letter-spacing: -0.12px;
    line-height: 25.8px;

    @media ${media.xl} {
      font-size: 33px;
      font-weight: 300;
      letter-spacing: -0.2px;
      line-height: 42px;
    }
  `,

  copy2: css`
    font-size: 19px;
    font-weight: 400;
    line-height: 24px;

    @media ${media.xl} {
      font-size: 28px;
      font-weight: 300;
      letter-spacing: -0.2px;
      line-height: 35px;
    }
  `,

  copy3: css`
    font-size: 19px;
    font-weight: 400;
    line-height: 24px;

    @media ${media.xl} {
      font-size: 24px;
      font-weight: 300;
      letter-spacing: -0.1px;
      line-height: 31px;
    }
  `,

  copy4: css`
    font-size: 17px;
    font-weight: 400;
    line-height: 24px;

    @media ${media.xl} {
      font-size: 20px;
      font-weight: 400;
      letter-spacing: -0.1px;
      line-height: 28px;
    }
  `,

  copy5: css`
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;

    @media ${media.xl} {
      font-size: 17px;
      font-weight: 400;
      line-height: 23px;
    }
  `,

  copy6: css`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;

    @media ${media.xl} {
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
    }
  `,

  headerSpacing: css`
    gap: 20px;

    @media ${media.xl} {
      gap: 30px;
    }
  `,
}
